import React from 'react';
import { string } from 'prop-types';
import { Box, Typography } from '@mui/material';
// // import { MIconMenu } from 'library';

import { formatFEIN } from 'feature/loading-management/utils/format';

//

const Header = ({ fein, title, viewBy }) => {
  return (
    <Box mb={viewBy === 'carrier' ? 2 : 1}>
      <Typography noWrap variant="h6">
        {title}
      </Typography>
      {viewBy === 'location' && (
        <Typography variant="body2">{`FEIN ${fein && formatFEIN(fein)}`}</Typography>
      )}
    </Box>
  );
};

Header.propTypes = {
  fein: string,
  title: string,
  viewBy: string.isRequired,
};

Header.defaultProps = {
  fein: '',
  title: '',
};

export default Header;
